import { render, staticRenderFns } from "./CustomFolderViewConfig.vue?vue&type=template&id=4fa7cbe6&scoped=true&"
import script from "./CustomFolderViewConfig.vue?vue&type=script&lang=js&"
export * from "./CustomFolderViewConfig.vue?vue&type=script&lang=js&"
import style0 from "./CustomFolderViewConfig.vue?vue&type=style&index=0&id=4fa7cbe6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa7cbe6",
  null
  
)

export default component.exports